const skin = {
	topLayout:"space",
	//bar in accordion
	barHeight:34,			//!!!Set the same in skin.less!!!
	tabbarHeight: 34,
	sidebarTitleHeight: 34,
	rowHeight:24,
	toolbarHeight:34,
	listItemHeight:28,		//list, grouplist, dataview, etc.
	unitHeaderHeight:20,
	propertyItemHeight:24,
	inputHeight: 30,
	buttonHeight: 30,
	inputPadding: 3,
	menuHeight: 28,
	labelTopHeight: 16,

	inputSpacing: 4,
	borderWidth: 1,

	sliderHandleWidth: 12,
	sliderPadding: 10,
	sliderBorder: 1,
	vSliderPadding:13,
	vSliderHeight:100,
	switchHeight:20,
	switchWidth:40,

	//margin - distance between cells
	layoutMargin:{ space:5, wide:5, clean:0, head:4, line:-1, toolbar:4, form:4, accordion: 5  },
	//padding - distance inside cell between cell border and cell content
	layoutPadding:{ space:5, wide:0, clean:0, head:0, line:0, toolbar:1, form:12, accordion: 0  },
	//space between tabs in tabbar
	tabMargin:3,
	tabOffset: 0,
	tabBottomOffset: 3,
	tabTopOffset:1,

	customCheckbox: true,
	customRadio: true,

	popupPadding: 8,

	dataPadding: 10,

	calendarHeight: 70,
	padding:0,
	accordionType: "accordion",

	optionHeight: 23
};

export default skin;